<template>
  <div class="form-group">
    <label :style="labelStyle" class="title-bold" for="telephone">
      {{ questionText }} {{ mandatoryQuestion ? '' : '(Opcional)' }}
    </label>
    <div style="display: flex;">

      <select v-model="selectedPhoneCode" class="form-control" :style="selectStyle" @change="handleSelectChange" @focus="isOpen = true" @blur="isOpen = false">
        <option v-for="country in CountryList" :key="country.id" :value="country.phone_Code">
          <span v-if="isOpen">+{{ country.phone_Code }} {{ country.country_Name }}</span>
          <span style="text-center" v-else>+{{ country.phone_Code }}</span>
        </option>
      </select>      

      <input
        type="number"
        style="margin-left: 8px !important;"
        class="form-control"
        id="telephone"
        :style="inputStyle"
        name="telephone"
        maxlength="9"
        :placeholder="getPlaceHolder"
        v-model="qtAnwser"
        @keyup.enter="enterKey"
        @keyup="allKeys"
        @input="handleInputChange"
        :disabled="processingApi"
      />
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import axios from "axios";

export default {
  name: "Survey-Question-Text",
  data() {
    return {
      qtAnwser: "",
      CountryList: [
        {
            "id": 1,
            "country_Name": "Afeganistão",
            "country_Name_En": "Afghanistan",
            "iso3": "AFG",
            "iso2": "AF",
            "phone_Code": "93"
        },
        {
            "id": 2,
            "country_Name": "Ilhas Åland",
            "country_Name_En": "Aland Islands",
            "iso3": "ALA",
            "iso2": "AX",
            "phone_Code": "358"
        },
        {
            "id": 3,
            "country_Name": "Albânia",
            "country_Name_En": "Albania",
            "iso3": "ALB",
            "iso2": "AL",
            "phone_Code": "355"
        },
        {
            "id": 4,
            "country_Name": "Argélia",
            "country_Name_En": "Algeria",
            "iso3": "DZA",
            "iso2": "DZ",
            "phone_Code": "213"
        },
        {
            "id": 5,
            "country_Name": "Samoa Americana",
            "country_Name_En": "American Samoa",
            "iso3": "ASM",
            "iso2": "AS",
            "phone_Code": "1"
        },
        {
            "id": 6,
            "country_Name": "Andorra",
            "country_Name_En": "Andorra",
            "iso3": "AND",
            "iso2": "AD",
            "phone_Code": "376"
        },
        {
            "id": 7,
            "country_Name": "Angola",
            "country_Name_En": "Angola",
            "iso3": "AGO",
            "iso2": "AO",
            "phone_Code": "244"
        },
        {
            "id": 8,
            "country_Name": "Anguila",
            "country_Name_En": "Anguilla",
            "iso3": "AIA",
            "iso2": "AI",
            "phone_Code": "1"
        },
        {
            "id": 9,
            "country_Name": "Território Antártico Britânico",
            "country_Name_En": "Antarctica",
            "iso3": "ATA",
            "iso2": "AQ",
            "phone_Code": "672"
        },
        {
            "id": 10,
            "country_Name": "Antígua e Barbuda",
            "country_Name_En": "Antigua and Barbuda",
            "iso3": "ATG",
            "iso2": "AG",
            "phone_Code": "1"
        },
        {
            "id": 11,
            "country_Name": "Argentina",
            "country_Name_En": "Argentina",
            "iso3": "ARG",
            "iso2": "AR",
            "phone_Code": "54"
        },
        {
            "id": 12,
            "country_Name": "Armênia",
            "country_Name_En": "Armenia",
            "iso3": "ARM",
            "iso2": "AM",
            "phone_Code": "374"
        },
        {
            "id": 13,
            "country_Name": "Aruba",
            "country_Name_En": "Aruba",
            "iso3": "ABW",
            "iso2": "AW",
            "phone_Code": "297"
        },
        {
            "id": 14,
            "country_Name": "Austrália",
            "country_Name_En": "Australia",
            "iso3": "AUS",
            "iso2": "AU",
            "phone_Code": "61"
        },
        {
            "id": 15,
            "country_Name": "Áustria",
            "country_Name_En": "Austria",
            "iso3": "AUT",
            "iso2": "AT",
            "phone_Code": "43"
        },
        {
            "id": 16,
            "country_Name": "Azerbaijão",
            "country_Name_En": "Azerbaijan",
            "iso3": "AZE",
            "iso2": "AZ",
            "phone_Code": "994"
        },
        {
            "id": 17,
            "country_Name": "Bahamas",
            "country_Name_En": "The Bahamas",
            "iso3": "BHS",
            "iso2": "BS",
            "phone_Code": "1"
        },
        {
            "id": 18,
            "country_Name": "Bahrein",
            "country_Name_En": "Bahrain",
            "iso3": "BHR",
            "iso2": "BH",
            "phone_Code": "973"
        },
        {
            "id": 19,
            "country_Name": "Bangladesh",
            "country_Name_En": "Bangladesh",
            "iso3": "BGD",
            "iso2": "BD",
            "phone_Code": "880"
        },
        {
            "id": 20,
            "country_Name": "Barbados",
            "country_Name_En": "Barbados",
            "iso3": "BRB",
            "iso2": "BB",
            "phone_Code": "1"
        },
        {
            "id": 21,
            "country_Name": "Bielorrússia",
            "country_Name_En": "Belarus",
            "iso3": "BLR",
            "iso2": "BY",
            "phone_Code": "375"
        },
        {
            "id": 22,
            "country_Name": "Bélgica",
            "country_Name_En": "Belgium",
            "iso3": "BEL",
            "iso2": "BE",
            "phone_Code": "32"
        },
        {
            "id": 23,
            "country_Name": "Belize",
            "country_Name_En": "Belize",
            "iso3": "BLZ",
            "iso2": "BZ",
            "phone_Code": "501"
        },
        {
            "id": 24,
            "country_Name": "Benin",
            "country_Name_En": "Benin",
            "iso3": "BEN",
            "iso2": "BJ",
            "phone_Code": "229"
        },
        {
            "id": 25,
            "country_Name": "Bermudas",
            "country_Name_En": "Bermuda",
            "iso3": "BMU",
            "iso2": "BM",
            "phone_Code": "1"
        },
        {
            "id": 26,
            "country_Name": "Butão",
            "country_Name_En": "Bhutan",
            "iso3": "BTN",
            "iso2": "BT",
            "phone_Code": "975"
        },
        {
            "id": 27,
            "country_Name": "Bolívia",
            "country_Name_En": "Bolivia",
            "iso3": "BOL",
            "iso2": "BO",
            "phone_Code": "591"
        },
        {
            "id": 28,
            "country_Name": "Bósnia e Herzegovina",
            "country_Name_En": "Bosnia and Herzegovina",
            "iso3": "BIH",
            "iso2": "BA",
            "phone_Code": "387"
        },
        {
            "id": 29,
            "country_Name": "Botsuana",
            "country_Name_En": "Botswana",
            "iso3": "BWA",
            "iso2": "BW",
            "phone_Code": "267"
        },
        {
            "id": 30,
            "country_Name": "Ilha Bouvet",
            "country_Name_En": "Bouvet Island",
            "iso3": "BVT",
            "iso2": "BV",
            "phone_Code": "0055"
        },
        {
            "id": 31,
            "country_Name": "Brasil",
            "country_Name_En": "Brazil",
            "iso3": "BRA",
            "iso2": "BR",
            "phone_Code": "55"
        },
        {
            "id": 32,
            "country_Name": "Território Britânico do Oceano Índico",
            "country_Name_En": "British Indian Ocean Territory",
            "iso3": "IOT",
            "iso2": "IO",
            "phone_Code": "246"
        },
        {
            "id": 33,
            "country_Name": "Brunei",
            "country_Name_En": "Brunei",
            "iso3": "BRN",
            "iso2": "BN",
            "phone_Code": "673"
        },
        {
            "id": 34,
            "country_Name": "Bulgária",
            "country_Name_En": "Bulgaria",
            "iso3": "BGR",
            "iso2": "BG",
            "phone_Code": "359"
        },
        {
            "id": 35,
            "country_Name": "Burquina Faso",
            "country_Name_En": "Burkina Faso",
            "iso3": "BFA",
            "iso2": "BF",
            "phone_Code": "226"
        },
        {
            "id": 36,
            "country_Name": "Burundi",
            "country_Name_En": "Burundi",
            "iso3": "BDI",
            "iso2": "BI",
            "phone_Code": "257"
        },
        {
            "id": 37,
            "country_Name": "Camboja",
            "country_Name_En": "Cambodia",
            "iso3": "KHM",
            "iso2": "KH",
            "phone_Code": "855"
        },
        {
            "id": 38,
            "country_Name": "Camarões",
            "country_Name_En": "Cameroon",
            "iso3": "CMR",
            "iso2": "CM",
            "phone_Code": "237"
        },
        {
            "id": 39,
            "country_Name": "Canadá",
            "country_Name_En": "Canada",
            "iso3": "CAN",
            "iso2": "CA",
            "phone_Code": "1"
        },
        {
            "id": 40,
            "country_Name": "Cabo Verde",
            "country_Name_En": "Cape Verde",
            "iso3": "CPV",
            "iso2": "CV",
            "phone_Code": "238"
        },
        {
            "id": 41,
            "country_Name": "Ilhas Cayman",
            "country_Name_En": "Cayman Islands",
            "iso3": "CYM",
            "iso2": "KY",
            "phone_Code": "1"
        },
        {
            "id": 42,
            "country_Name": "República Centro-Africana",
            "country_Name_En": "Central African Republic",
            "iso3": "CAF",
            "iso2": "CF",
            "phone_Code": "236"
        },
        {
            "id": 43,
            "country_Name": "Chade",
            "country_Name_En": "Chad",
            "iso3": "TCD",
            "iso2": "TD",
            "phone_Code": "235"
        },
        {
            "id": 44,
            "country_Name": "Chile",
            "country_Name_En": "Chile",
            "iso3": "CHL",
            "iso2": "CL",
            "phone_Code": "56"
        },
        {
            "id": 45,
            "country_Name": "China",
            "country_Name_En": "China",
            "iso3": "CHN",
            "iso2": "CN",
            "phone_Code": "86"
        },
        {
            "id": 46,
            "country_Name": "Ilha Christmas",
            "country_Name_En": "Christmas Island",
            "iso3": "CXR",
            "iso2": "CX",
            "phone_Code": "61"
        },
        {
            "id": 47,
            "country_Name": "Ilhas Cocos",
            "country_Name_En": "Cocos (Keeling) Islands",
            "iso3": "CCK",
            "iso2": "CC",
            "phone_Code": "61"
        },
        {
            "id": 48,
            "country_Name": "Colômbia",
            "country_Name_En": "Colombia",
            "iso3": "COL",
            "iso2": "CO",
            "phone_Code": "57"
        },
        {
            "id": 49,
            "country_Name": "Comores",
            "country_Name_En": "Comoros",
            "iso3": "COM",
            "iso2": "KM",
            "phone_Code": "269"
        },
        {
            "id": 50,
            "country_Name": "Congo",
            "country_Name_En": "Congo",
            "iso3": "COG",
            "iso2": "CG",
            "phone_Code": "242"
        },
        {
            "id": 51,
            "country_Name": "República Democrática do Congo",
            "country_Name_En": "Democratic Republic of the Congo",
            "iso3": "COD",
            "iso2": "CD",
            "phone_Code": "243"
        },
        {
            "id": 52,
            "country_Name": "Ilhas Cook",
            "country_Name_En": "Cook Islands",
            "iso3": "COK",
            "iso2": "CK",
            "phone_Code": "682"
        },
        {
            "id": 53,
            "country_Name": "Costa Rica",
            "country_Name_En": "Costa Rica",
            "iso3": "CRI",
            "iso2": "CR",
            "phone_Code": "506"
        },
        {
            "id": 54,
            "country_Name": "Costa do Marfim",
            "country_Name_En": "Cote D'Ivoire (Ivory Coast)",
            "iso3": "CIV",
            "iso2": "CI",
            "phone_Code": "225"
        },
        {
            "id": 55,
            "country_Name": "Croácia",
            "country_Name_En": "Croatia",
            "iso3": "HRV",
            "iso2": "HR",
            "phone_Code": "385"
        },
        {
            "id": 56,
            "country_Name": "Cuba",
            "country_Name_En": "Cuba",
            "iso3": "CUB",
            "iso2": "CU",
            "phone_Code": "53"
        },
        {
            "id": 57,
            "country_Name": "Chipre",
            "country_Name_En": "Cyprus",
            "iso3": "CYP",
            "iso2": "CY",
            "phone_Code": "357"
        },
        {
            "id": 58,
            "country_Name": "República Tcheca",
            "country_Name_En": "Czech Republic",
            "iso3": "CZE",
            "iso2": "CZ",
            "phone_Code": "420"
        },
        {
            "id": 59,
            "country_Name": "Dinamarca",
            "country_Name_En": "Denmark",
            "iso3": "DNK",
            "iso2": "DK",
            "phone_Code": "45"
        },
        {
            "id": 60,
            "country_Name": "Djibuti",
            "country_Name_En": "Djibouti",
            "iso3": "DJI",
            "iso2": "DJ",
            "phone_Code": "253"
        },
        {
            "id": 61,
            "country_Name": "Dominica",
            "country_Name_En": "Dominica",
            "iso3": "DMA",
            "iso2": "DM",
            "phone_Code": "1"
        },
        {
            "id": 62,
            "country_Name": "República Dominicana",
            "country_Name_En": "Dominican Republic",
            "iso3": "DOM",
            "iso2": "DO",
            "phone_Code": "1"
        },
        {
            "id": 63,
            "country_Name": "Timor-Leste",
            "country_Name_En": "Timor-Leste",
            "iso3": "TLS",
            "iso2": "TL",
            "phone_Code": "670"
        },
        {
            "id": 64,
            "country_Name": "Equador",
            "country_Name_En": "Ecuador",
            "iso3": "ECU",
            "iso2": "EC",
            "phone_Code": "593"
        },
        {
            "id": 65,
            "country_Name": "Egito",
            "country_Name_En": "Egypt",
            "iso3": "EGY",
            "iso2": "EG",
            "phone_Code": "20"
        },
        {
            "id": 66,
            "country_Name": "El Salvador",
            "country_Name_En": "El Salvador",
            "iso3": "SLV",
            "iso2": "SV",
            "phone_Code": "503"
        },
        {
            "id": 67,
            "country_Name": "Guiné Equatorial",
            "country_Name_En": "Equatorial Guinea",
            "iso3": "GNQ",
            "iso2": "GQ",
            "phone_Code": "240"
        },
        {
            "id": 68,
            "country_Name": "Eritreia",
            "country_Name_En": "Eritrea",
            "iso3": "ERI",
            "iso2": "ER",
            "phone_Code": "291"
        },
        {
            "id": 69,
            "country_Name": "Estônia",
            "country_Name_En": "Estonia",
            "iso3": "EST",
            "iso2": "EE",
            "phone_Code": "372"
        },
        {
            "id": 70,
            "country_Name": "Etiópia",
            "country_Name_En": "Ethiopia",
            "iso3": "ETH",
            "iso2": "ET",
            "phone_Code": "251"
        },
        {
            "id": 71,
            "country_Name": "Ilhas Malvinas",
            "country_Name_En": "Falkland Islands",
            "iso3": "FLK",
            "iso2": "FK",
            "phone_Code": "500"
        },
        {
            "id": 72,
            "country_Name": "Ilhas Faroe",
            "country_Name_En": "Faroe Islands",
            "iso3": "FRO",
            "iso2": "FO",
            "phone_Code": "298"
        },
        {
            "id": 73,
            "country_Name": "Fiji",
            "country_Name_En": "Fiji Islands",
            "iso3": "FJI",
            "iso2": "FJ",
            "phone_Code": "679"
        },
        {
            "id": 74,
            "country_Name": "Finlândia",
            "country_Name_En": "Finland",
            "iso3": "FIN",
            "iso2": "FI",
            "phone_Code": "358"
        },
        {
            "id": 75,
            "country_Name": "França",
            "country_Name_En": "France",
            "iso3": "FRA",
            "iso2": "FR",
            "phone_Code": "33"
        },
        {
            "id": 76,
            "country_Name": "Guiana Francesa",
            "country_Name_En": "French Guiana",
            "iso3": "GUF",
            "iso2": "GF",
            "phone_Code": "594"
        },
        {
            "id": 77,
            "country_Name": "Polinésia Francesa",
            "country_Name_En": "French Polynesia",
            "iso3": "PYF",
            "iso2": "PF",
            "phone_Code": "689"
        },
        {
            "id": 78,
            "country_Name": "Territórios Austrais Franceses",
            "country_Name_En": "French Southern Territories",
            "iso3": "ATF",
            "iso2": "TF",
            "phone_Code": "262"
        },
        {
            "id": 79,
            "country_Name": "Gabão",
            "country_Name_En": "Gabon",
            "iso3": "GAB",
            "iso2": "GA",
            "phone_Code": "241"
        },
        {
            "id": 80,
            "country_Name": "Gâmbia",
            "country_Name_En": "The Gambia ",
            "iso3": "GMB",
            "iso2": "GM",
            "phone_Code": "220"
        },
        {
            "id": 81,
            "country_Name": "Geórgia",
            "country_Name_En": "Georgia",
            "iso3": "GEO",
            "iso2": "GE",
            "phone_Code": "995"
        },
        {
            "id": 82,
            "country_Name": "Alemanha",
            "country_Name_En": "Germany",
            "iso3": "DEU",
            "iso2": "DE",
            "phone_Code": "49"
        },
        {
            "id": 83,
            "country_Name": "Gana",
            "country_Name_En": "Ghana",
            "iso3": "GHA",
            "iso2": "GH",
            "phone_Code": "233"
        },
        {
            "id": 84,
            "country_Name": "Gibraltar",
            "country_Name_En": "Gibraltar",
            "iso3": "GIB",
            "iso2": "GI",
            "phone_Code": "350"
        },
        {
            "id": 85,
            "country_Name": "Grécia",
            "country_Name_En": "Greece",
            "iso3": "GRC",
            "iso2": "GR",
            "phone_Code": "30"
        },
        {
            "id": 86,
            "country_Name": "Groenlândia",
            "country_Name_En": "Greenland",
            "iso3": "GRL",
            "iso2": "GL",
            "phone_Code": "299"
        },
        {
            "id": 87,
            "country_Name": "Granada",
            "country_Name_En": "Grenada",
            "iso3": "GRD",
            "iso2": "GD",
            "phone_Code": "1"
        },
        {
            "id": 88,
            "country_Name": "Guadalupe",
            "country_Name_En": "Guadeloupe",
            "iso3": "GLP",
            "iso2": "GP",
            "phone_Code": "590"
        },
        {
            "id": 89,
            "country_Name": "Guam",
            "country_Name_En": "Guam",
            "iso3": "GUM",
            "iso2": "GU",
            "phone_Code": "1"
        },
        {
            "id": 90,
            "country_Name": "Guatemala",
            "country_Name_En": "Guatemala",
            "iso3": "GTM",
            "iso2": "GT",
            "phone_Code": "502"
        },
        {
            "id": 91,
            "country_Name": "Guernsey",
            "country_Name_En": "Guernsey and Alderney",
            "iso3": "GGY",
            "iso2": "GG",
            "phone_Code": "44"
        },
        {
            "id": 92,
            "country_Name": "Guiné",
            "country_Name_En": "Guinea",
            "iso3": "GIN",
            "iso2": "GN",
            "phone_Code": "224"
        },
        {
            "id": 93,
            "country_Name": "Guiné-Bissau",
            "country_Name_En": "Guinea-Bissau",
            "iso3": "GNB",
            "iso2": "GW",
            "phone_Code": "245"
        },
        {
            "id": 94,
            "country_Name": "Guiana",
            "country_Name_En": "Guyana",
            "iso3": "GUY",
            "iso2": "GY",
            "phone_Code": "592"
        },
        {
            "id": 95,
            "country_Name": "Haiti",
            "country_Name_En": "Haiti",
            "iso3": "HTI",
            "iso2": "HT",
            "phone_Code": "509"
        },
        {
            "id": 96,
            "country_Name": "Ilhas Heard e Ilhas McDonald",
            "country_Name_En": "Heard Island and McDonald Islands",
            "iso3": "HMD",
            "iso2": "HM",
            "phone_Code": "672"
        },
        {
            "id": 97,
            "country_Name": "Honduras",
            "country_Name_En": "Honduras",
            "iso3": "HND",
            "iso2": "HN",
            "phone_Code": "504"
        },
        {
            "id": 98,
            "country_Name": "Hong Kong",
            "country_Name_En": "Hong Kong S.A.R.",
            "iso3": "HKG",
            "iso2": "HK",
            "phone_Code": "852"
        },
        {
            "id": 99,
            "country_Name": "Hungria",
            "country_Name_En": "Hungary",
            "iso3": "HUN",
            "iso2": "HU",
            "phone_Code": "36"
        },
        {
            "id": 100,
            "country_Name": "Islândia",
            "country_Name_En": "Iceland",
            "iso3": "ISL",
            "iso2": "IS",
            "phone_Code": "354"
        },
        {
            "id": 101,
            "country_Name": "Índia",
            "country_Name_En": "India",
            "iso3": "IND",
            "iso2": "IN",
            "phone_Code": "91"
        },
        {
            "id": 102,
            "country_Name": "Indonésia",
            "country_Name_En": "Indonesia",
            "iso3": "IDN",
            "iso2": "ID",
            "phone_Code": "62"
        },
        {
            "id": 103,
            "country_Name": "Irã",
            "country_Name_En": "Iran",
            "iso3": "IRN",
            "iso2": "IR",
            "phone_Code": "98"
        },
        {
            "id": 104,
            "country_Name": "Iraque",
            "country_Name_En": "Iraq",
            "iso3": "IRQ",
            "iso2": "IQ",
            "phone_Code": "964"
        },
        {
            "id": 105,
            "country_Name": "Irlanda",
            "country_Name_En": "Ireland",
            "iso3": "IRL",
            "iso2": "IE",
            "phone_Code": "353"
        },
        {
            "id": 106,
            "country_Name": "Israel",
            "country_Name_En": "Israel",
            "iso3": "ISR",
            "iso2": "IL",
            "phone_Code": "972"
        },
        {
            "id": 107,
            "country_Name": "Itália",
            "country_Name_En": "Italy",
            "iso3": "ITA",
            "iso2": "IT",
            "phone_Code": "39"
        },
        {
            "id": 108,
            "country_Name": "Jamaica",
            "country_Name_En": "Jamaica",
            "iso3": "JAM",
            "iso2": "JM",
            "phone_Code": "1"
        },
        {
            "id": 109,
            "country_Name": "Japão",
            "country_Name_En": "Japan",
            "iso3": "JPN",
            "iso2": "JP",
            "phone_Code": "81"
        },
        {
            "id": 110,
            "country_Name": "Jersey",
            "country_Name_En": "Jersey",
            "iso3": "JEY",
            "iso2": "JE",
            "phone_Code": "44"
        },
        {
            "id": 111,
            "country_Name": "Jordânia",
            "country_Name_En": "Jordan",
            "iso3": "JOR",
            "iso2": "JO",
            "phone_Code": "962"
        },
        {
            "id": 112,
            "country_Name": "Cazaquistão",
            "country_Name_En": "Kazakhstan",
            "iso3": "KAZ",
            "iso2": "KZ",
            "phone_Code": "7"
        },
        {
            "id": 113,
            "country_Name": "Quênia",
            "country_Name_En": "Kenya",
            "iso3": "KEN",
            "iso2": "KE",
            "phone_Code": "254"
        },
        {
            "id": 114,
            "country_Name": "Kiribati",
            "country_Name_En": "Kiribati",
            "iso3": "KIR",
            "iso2": "KI",
            "phone_Code": "686"
        },
        {
            "id": 115,
            "country_Name": "Coreia do Norte",
            "country_Name_En": "North Korea",
            "iso3": "PRK",
            "iso2": "KP",
            "phone_Code": "850"
        },
        {
            "id": 116,
            "country_Name": "Coreia do Sul",
            "country_Name_En": "South Korea",
            "iso3": "KOR",
            "iso2": "KR",
            "phone_Code": "82"
        },
        {
            "id": 117,
            "country_Name": "Kuwait",
            "country_Name_En": "Kuwait",
            "iso3": "KWT",
            "iso2": "KW",
            "phone_Code": "965"
        },
        {
            "id": 118,
            "country_Name": "Quirguistão",
            "country_Name_En": "Kyrgyzstan",
            "iso3": "KGZ",
            "iso2": "KG",
            "phone_Code": "996"
        },
        {
            "id": 119,
            "country_Name": "Laos",
            "country_Name_En": "Laos",
            "iso3": "LAO",
            "iso2": "LA",
            "phone_Code": "856"
        },
        {
            "id": 120,
            "country_Name": "Letônia",
            "country_Name_En": "Latvia",
            "iso3": "LVA",
            "iso2": "LV",
            "phone_Code": "371"
        },
        {
            "id": 121,
            "country_Name": "Líbano",
            "country_Name_En": "Lebanon",
            "iso3": "LBN",
            "iso2": "LB",
            "phone_Code": "961"
        },
        {
            "id": 122,
            "country_Name": "Lesoto",
            "country_Name_En": "Lesotho",
            "iso3": "LSO",
            "iso2": "LS",
            "phone_Code": "266"
        },
        {
            "id": 123,
            "country_Name": "Libéria",
            "country_Name_En": "Liberia",
            "iso3": "LBR",
            "iso2": "LR",
            "phone_Code": "231"
        },
        {
            "id": 124,
            "country_Name": "Líbia",
            "country_Name_En": "Libya",
            "iso3": "LBY",
            "iso2": "LY",
            "phone_Code": "218"
        },
        {
            "id": 125,
            "country_Name": "Liechtenstein",
            "country_Name_En": "Liechtenstein",
            "iso3": "LIE",
            "iso2": "LI",
            "phone_Code": "423"
        },
        {
            "id": 126,
            "country_Name": "Lituânia",
            "country_Name_En": "Lithuania",
            "iso3": "LTU",
            "iso2": "LT",
            "phone_Code": "370"
        },
        {
            "id": 127,
            "country_Name": "Luxemburgo",
            "country_Name_En": "Luxembourg",
            "iso3": "LUX",
            "iso2": "LU",
            "phone_Code": "352"
        },
        {
            "id": 128,
            "country_Name": "Macau",
            "country_Name_En": "Macau S.A.R.",
            "iso3": "MAC",
            "iso2": "MO",
            "phone_Code": "853"
        },
        {
            "id": 129,
            "country_Name": "Macedônia do Norte",
            "country_Name_En": "North Macedonia",
            "iso3": "MKD",
            "iso2": "MK",
            "phone_Code": "389"
        },
        {
            "id": 130,
            "country_Name": "Madagascar",
            "country_Name_En": "Madagascar",
            "iso3": "MDG",
            "iso2": "MG",
            "phone_Code": "261"
        },
        {
            "id": 131,
            "country_Name": "Maláui",
            "country_Name_En": "Malawi",
            "iso3": "MWI",
            "iso2": "MW",
            "phone_Code": "265"
        },
        {
            "id": 132,
            "country_Name": "Malásia",
            "country_Name_En": "Malaysia",
            "iso3": "MYS",
            "iso2": "MY",
            "phone_Code": "60"
        },
        {
            "id": 133,
            "country_Name": "Maldivas",
            "country_Name_En": "Maldives",
            "iso3": "MDV",
            "iso2": "MV",
            "phone_Code": "960"
        },
        {
            "id": 134,
            "country_Name": "Mali",
            "country_Name_En": "Mali",
            "iso3": "MLI",
            "iso2": "ML",
            "phone_Code": "223"
        },
        {
            "id": 135,
            "country_Name": "Malta",
            "country_Name_En": "Malta",
            "iso3": "MLT",
            "iso2": "MT",
            "phone_Code": "356"
        },
        {
            "id": 136,
            "country_Name": "Ilha de Man",
            "country_Name_En": "Man (Isle of)",
            "iso3": "IMN",
            "iso2": "IM",
            "phone_Code": "44"
        },
        {
            "id": 137,
            "country_Name": "Ilhas Marshall",
            "country_Name_En": "Marshall Islands",
            "iso3": "MHL",
            "iso2": "MH",
            "phone_Code": "692"
        },
        {
            "id": 138,
            "country_Name": "Martinica",
            "country_Name_En": "Martinique",
            "iso3": "MTQ",
            "iso2": "MQ",
            "phone_Code": "596"
        },
        {
            "id": 139,
            "country_Name": "Mauritânia",
            "country_Name_En": "Mauritania",
            "iso3": "MRT",
            "iso2": "MR",
            "phone_Code": "222"
        },
        {
            "id": 140,
            "country_Name": "Maurício",
            "country_Name_En": "Mauritius",
            "iso3": "MUS",
            "iso2": "MU",
            "phone_Code": "230"
        },
        {
            "id": 141,
            "country_Name": "Mayotte",
            "country_Name_En": "Mayotte",
            "iso3": "MYT",
            "iso2": "YT",
            "phone_Code": "262"
        },
        {
            "id": 142,
            "country_Name": "México",
            "country_Name_En": "Mexico",
            "iso3": "MEX",
            "iso2": "MX",
            "phone_Code": "52"
        },
        {
            "id": 143,
            "country_Name": "Micronésia",
            "country_Name_En": "Micronesia",
            "iso3": "FSM",
            "iso2": "FM",
            "phone_Code": "691"
        },
        {
            "id": 144,
            "country_Name": "Moldova",
            "country_Name_En": "Moldova",
            "iso3": "MDA",
            "iso2": "MD",
            "phone_Code": "373"
        },
        {
            "id": 145,
            "country_Name": "Mônaco",
            "country_Name_En": "Monaco",
            "iso3": "MCO",
            "iso2": "MC",
            "phone_Code": "377"
        },
        {
            "id": 146,
            "country_Name": "Mongólia",
            "country_Name_En": "Mongolia",
            "iso3": "MNG",
            "iso2": "MN",
            "phone_Code": "976"
        },
        {
            "id": 147,
            "country_Name": "Montenegro",
            "country_Name_En": "Montenegro",
            "iso3": "MNE",
            "iso2": "ME",
            "phone_Code": "382"
        },
        {
            "id": 148,
            "country_Name": "Montserrat",
            "country_Name_En": "Montserrat",
            "iso3": "MSR",
            "iso2": "MS",
            "phone_Code": "1"
        },
        {
            "id": 149,
            "country_Name": "Marrocos",
            "country_Name_En": "Morocco",
            "iso3": "MAR",
            "iso2": "MA",
            "phone_Code": "212"
        },
        {
            "id": 150,
            "country_Name": "Moçambique",
            "country_Name_En": "Mozambique",
            "iso3": "MOZ",
            "iso2": "MZ",
            "phone_Code": "258"
        },
        {
            "id": 151,
            "country_Name": "Mianmar (Birmânia)",
            "country_Name_En": "Myanmar",
            "iso3": "MMR",
            "iso2": "MM",
            "phone_Code": "95"
        },
        {
            "id": 152,
            "country_Name": "Namíbia",
            "country_Name_En": "Namibia",
            "iso3": "NAM",
            "iso2": "NA",
            "phone_Code": "264"
        },
        {
            "id": 153,
            "country_Name": "Nauru",
            "country_Name_En": "Nauru",
            "iso3": "NRU",
            "iso2": "NR",
            "phone_Code": "674"
        },
        {
            "id": 154,
            "country_Name": "Nepal",
            "country_Name_En": "Nepal",
            "iso3": "NPL",
            "iso2": "NP",
            "phone_Code": "977"
        },
        {
            "id": 155,
            "country_Name": "Bonaire, Sint Eustatius e Saba",
            "country_Name_En": "Bonaire, Sint Eustatius and Saba",
            "iso3": "BES",
            "iso2": "BQ",
            "phone_Code": "599"
        },
        {
            "id": 156,
            "country_Name": "Holanda",
            "country_Name_En": "Netherlands",
            "iso3": "NLD",
            "iso2": "NL",
            "phone_Code": "31"
        },
        {
            "id": 157,
            "country_Name": "Nova Caledônia",
            "country_Name_En": "New Caledonia",
            "iso3": "NCL",
            "iso2": "NC",
            "phone_Code": "687"
        },
        {
            "id": 158,
            "country_Name": "Nova Zelândia",
            "country_Name_En": "New Zealand",
            "iso3": "NZL",
            "iso2": "NZ",
            "phone_Code": "64"
        },
        {
            "id": 159,
            "country_Name": "Nicarágua",
            "country_Name_En": "Nicaragua",
            "iso3": "NIC",
            "iso2": "NI",
            "phone_Code": "505"
        },
        {
            "id": 160,
            "country_Name": "Níger",
            "country_Name_En": "Niger",
            "iso3": "NER",
            "iso2": "NE",
            "phone_Code": "227"
        },
        {
            "id": 161,
            "country_Name": "Nigéria",
            "country_Name_En": "Nigeria",
            "iso3": "NGA",
            "iso2": "NG",
            "phone_Code": "234"
        },
        {
            "id": 162,
            "country_Name": "Niue",
            "country_Name_En": "Niue",
            "iso3": "NIU",
            "iso2": "NU",
            "phone_Code": "683"
        },
        {
            "id": 163,
            "country_Name": "Ilhas Norfolk",
            "country_Name_En": "Norfolk Island",
            "iso3": "NFK",
            "iso2": "NF",
            "phone_Code": "672"
        },
        {
            "id": 164,
            "country_Name": "Ilhas Marianas do Norte",
            "country_Name_En": "Northern Mariana Islands",
            "iso3": "MNP",
            "iso2": "MP",
            "phone_Code": "1"
        },
        {
            "id": 165,
            "country_Name": "Noruega",
            "country_Name_En": "Norway",
            "iso3": "NOR",
            "iso2": "NO",
            "phone_Code": "47"
        },
        {
            "id": 166,
            "country_Name": "Omã",
            "country_Name_En": "Oman",
            "iso3": "OMN",
            "iso2": "OM",
            "phone_Code": "968"
        },
        {
            "id": 167,
            "country_Name": "Paquistão",
            "country_Name_En": "Pakistan",
            "iso3": "PAK",
            "iso2": "PK",
            "phone_Code": "92"
        },
        {
            "id": 168,
            "country_Name": "Palau",
            "country_Name_En": "Palau",
            "iso3": "PLW",
            "iso2": "PW",
            "phone_Code": "680"
        },
        {
            "id": 169,
            "country_Name": "Território Palestino Ocupado",
            "country_Name_En": "Palestinian Territory Occupied",
            "iso3": "PSE",
            "iso2": "PS",
            "phone_Code": "970"
        },
        {
            "id": 170,
            "country_Name": "Panamá",
            "country_Name_En": "Panama",
            "iso3": "PAN",
            "iso2": "PA",
            "phone_Code": "507"
        },
        {
            "id": 171,
            "country_Name": "Papua-Nova Guiné",
            "country_Name_En": "Papua New Guinea",
            "iso3": "PNG",
            "iso2": "PG",
            "phone_Code": "675"
        },
        {
            "id": 172,
            "country_Name": "Paraguai",
            "country_Name_En": "Paraguay",
            "iso3": "PRY",
            "iso2": "PY",
            "phone_Code": "595"
        },
        {
            "id": 173,
            "country_Name": "Peru",
            "country_Name_En": "Peru",
            "iso3": "PER",
            "iso2": "PE",
            "phone_Code": "51"
        },
        {
            "id": 174,
            "country_Name": "Filipinas",
            "country_Name_En": "Philippines",
            "iso3": "PHL",
            "iso2": "PH",
            "phone_Code": "63"
        },
        {
            "id": 175,
            "country_Name": "Ilha de Pitcairn",
            "country_Name_En": "Pitcairn Island",
            "iso3": "PCN",
            "iso2": "PN",
            "phone_Code": "870"
        },
        {
            "id": 176,
            "country_Name": "Polônia",
            "country_Name_En": "Poland",
            "iso3": "POL",
            "iso2": "PL",
            "phone_Code": "48"
        },
        {
            "id": 177,
            "country_Name": "Portugal",
            "country_Name_En": "Portugal",
            "iso3": "PRT",
            "iso2": "PT",
            "phone_Code": "351"
        },
        {
            "id": 178,
            "country_Name": "Porto Rico",
            "country_Name_En": "Puerto Rico",
            "iso3": "PRI",
            "iso2": "PR",
            "phone_Code": "1"
        },
        {
            "id": 179,
            "country_Name": "Qatar",
            "country_Name_En": "Qatar",
            "iso3": "QAT",
            "iso2": "QA",
            "phone_Code": "974"
        },
        {
            "id": 180,
            "country_Name": "Reunião, Ilha",
            "country_Name_En": "Reunion",
            "iso3": "REU",
            "iso2": "RE",
            "phone_Code": "262"
        },
        {
            "id": 181,
            "country_Name": "Romênia",
            "country_Name_En": "Romania",
            "iso3": "ROU",
            "iso2": "RO",
            "phone_Code": "40"
        },
        {
            "id": 182,
            "country_Name": "Rússia (antiga URSS) - Federação Russa",
            "country_Name_En": "Russia",
            "iso3": "RUS",
            "iso2": "RU",
            "phone_Code": "7"
        },
        {
            "id": 183,
            "country_Name": "Ruanda",
            "country_Name_En": "Rwanda",
            "iso3": "RWA",
            "iso2": "RW",
            "phone_Code": "250"
        },
        {
            "id": 184,
            "country_Name": "Santa Helena",
            "country_Name_En": "Saint Helena",
            "iso3": "SHN",
            "iso2": "SH",
            "phone_Code": "290"
        },
        {
            "id": 185,
            "country_Name": "São Cristóvão e Nevis",
            "country_Name_En": "Saint Kitts and Nevis",
            "iso3": "KNA",
            "iso2": "KN",
            "phone_Code": "1"
        },
        {
            "id": 186,
            "country_Name": "Santa Lúcia",
            "country_Name_En": "Saint Lucia",
            "iso3": "LCA",
            "iso2": "LC",
            "phone_Code": "1"
        },
        {
            "id": 187,
            "country_Name": "São Pedro e Miquelon",
            "country_Name_En": "Saint Pierre and Miquelon",
            "iso3": "SPM",
            "iso2": "PM",
            "phone_Code": "508"
        },
        {
            "id": 188,
            "country_Name": "São Vicente e Granadinas",
            "country_Name_En": "Saint Vincent and the Grenadines",
            "iso3": "VCT",
            "iso2": "VC",
            "phone_Code": "1"
        },
        {
            "id": 189,
            "country_Name": "São Bartolomeu",
            "country_Name_En": "Saint-Barthelemy",
            "iso3": "BLM",
            "iso2": "BL",
            "phone_Code": "590"
        },
        {
            "id": 190,
            "country_Name": "São Martinho (parte francesa)",
            "country_Name_En": "Saint-Martin (French part)",
            "iso3": "MAF",
            "iso2": "MF",
            "phone_Code": "590"
        },
        {
            "id": 191,
            "country_Name": "Samoa Ocidental",
            "country_Name_En": "Samoa",
            "iso3": "WSM",
            "iso2": "WS",
            "phone_Code": "685"
        },
        {
            "id": 192,
            "country_Name": "San Marino",
            "country_Name_En": "San Marino",
            "iso3": "SMR",
            "iso2": "SM",
            "phone_Code": "378"
        },
        {
            "id": 193,
            "country_Name": "Ilhas São Tomé e Príncipe",
            "country_Name_En": "Sao Tome and Principe",
            "iso3": "STP",
            "iso2": "ST",
            "phone_Code": "239"
        },
        {
            "id": 194,
            "country_Name": "Arábia Saudita",
            "country_Name_En": "Saudi Arabia",
            "iso3": "SAU",
            "iso2": "SA",
            "phone_Code": "966"
        },
        {
            "id": 195,
            "country_Name": "Senegal",
            "country_Name_En": "Senegal",
            "iso3": "SEN",
            "iso2": "SN",
            "phone_Code": "221"
        },
        {
            "id": 196,
            "country_Name": "Sérvia",
            "country_Name_En": "Serbia",
            "iso3": "SRB",
            "iso2": "RS",
            "phone_Code": "381"
        },
        {
            "id": 197,
            "country_Name": "Ilhas Seychelles",
            "country_Name_En": "Seychelles",
            "iso3": "SYC",
            "iso2": "SC",
            "phone_Code": "248"
        },
        {
            "id": 198,
            "country_Name": "Serra Leoa",
            "country_Name_En": "Sierra Leone",
            "iso3": "SLE",
            "iso2": "SL",
            "phone_Code": "232"
        },
        {
            "id": 199,
            "country_Name": "Cingapura",
            "country_Name_En": "Singapore",
            "iso3": "SGP",
            "iso2": "SG",
            "phone_Code": "65"
        },
        {
            "id": 200,
            "country_Name": "Eslováquia",
            "country_Name_En": "Slovakia",
            "iso3": "SVK",
            "iso2": "SK",
            "phone_Code": "421"
        },
        {
            "id": 201,
            "country_Name": "Eslovênia",
            "country_Name_En": "Slovenia",
            "iso3": "SVN",
            "iso2": "SI",
            "phone_Code": "386"
        },
        {
            "id": 202,
            "country_Name": "Ilhas Salomão",
            "country_Name_En": "Solomon Islands",
            "iso3": "SLB",
            "iso2": "SB",
            "phone_Code": "677"
        },
        {
            "id": 203,
            "country_Name": "Somália",
            "country_Name_En": "Somalia",
            "iso3": "SOM",
            "iso2": "SO",
            "phone_Code": "252"
        },
        {
            "id": 204,
            "country_Name": "África do Sul",
            "country_Name_En": "South Africa",
            "iso3": "ZAF",
            "iso2": "ZA",
            "phone_Code": "27"
        },
        {
            "id": 205,
            "country_Name": "Geórgia do Sul",
            "country_Name_En": "South Georgia",
            "iso3": "SGS",
            "iso2": "GS",
            "phone_Code": "500"
        },
        {
            "id": 206,
            "country_Name": "Sudão do Sul",
            "country_Name_En": "South Sudan",
            "iso3": "SSD",
            "iso2": "SS",
            "phone_Code": "211"
        },
        {
            "id": 207,
            "country_Name": "Espanha",
            "country_Name_En": "Spain",
            "iso3": "ESP",
            "iso2": "ES",
            "phone_Code": "34"
        },
        {
            "id": 208,
            "country_Name": "Sri Lanka",
            "country_Name_En": "Sri Lanka",
            "iso3": "LKA",
            "iso2": "LK",
            "phone_Code": "94"
        },
        {
            "id": 209,
            "country_Name": "Sudão",
            "country_Name_En": "Sudan",
            "iso3": "SDN",
            "iso2": "SD",
            "phone_Code": "249"
        },
        {
            "id": 210,
            "country_Name": "Suriname",
            "country_Name_En": "Suriname",
            "iso3": "SUR",
            "iso2": "SR",
            "phone_Code": "597"
        },
        {
            "id": 211,
            "country_Name": "Ilhas Svalbard e Jan Mayen",
            "country_Name_En": "Svalbard and Jan Mayen Islands",
            "iso3": "SJM",
            "iso2": "SJ",
            "phone_Code": "47"
        },
        {
            "id": 212,
            "country_Name": "Essuatíni",
            "country_Name_En": "Eswatini",
            "iso3": "SWZ",
            "iso2": "SZ",
            "phone_Code": "268"
        },
        {
            "id": 213,
            "country_Name": "Suécia",
            "country_Name_En": "Sweden",
            "iso3": "SWE",
            "iso2": "SE",
            "phone_Code": "46"
        },
        {
            "id": 214,
            "country_Name": "Suíça",
            "country_Name_En": "Switzerland",
            "iso3": "CHE",
            "iso2": "CH",
            "phone_Code": "41"
        },
        {
            "id": 215,
            "country_Name": "Síria",
            "country_Name_En": "Syria",
            "iso3": "SYR",
            "iso2": "SY",
            "phone_Code": "963"
        },
        {
            "id": 216,
            "country_Name": "Taiwan",
            "country_Name_En": "Taiwan",
            "iso3": "TWN",
            "iso2": "TW",
            "phone_Code": "886"
        },
        {
            "id": 217,
            "country_Name": "Tadjiquistão",
            "country_Name_En": "Tajikistan",
            "iso3": "TJK",
            "iso2": "TJ",
            "phone_Code": "992"
        },
        {
            "id": 218,
            "country_Name": "Tanzânia",
            "country_Name_En": "Tanzania",
            "iso3": "TZA",
            "iso2": "TZ",
            "phone_Code": "255"
        },
        {
            "id": 219,
            "country_Name": "Tailândia",
            "country_Name_En": "Thailand",
            "iso3": "THA",
            "iso2": "TH",
            "phone_Code": "66"
        },
        {
            "id": 220,
            "country_Name": "Togo",
            "country_Name_En": "Togo",
            "iso3": "TGO",
            "iso2": "TG",
            "phone_Code": "228"
        },
        {
            "id": 221,
            "country_Name": "Ilhas Tokelau",
            "country_Name_En": "Tokelau",
            "iso3": "TKL",
            "iso2": "TK",
            "phone_Code": "690"
        },
        {
            "id": 222,
            "country_Name": "Tonga",
            "country_Name_En": "Tonga",
            "iso3": "TON",
            "iso2": "TO",
            "phone_Code": "676"
        },
        {
            "id": 223,
            "country_Name": "Trinidad e Tobago",
            "country_Name_En": "Trinidad and Tobago",
            "iso3": "TTO",
            "iso2": "TT",
            "phone_Code": "1"
        },
        {
            "id": 224,
            "country_Name": "Tunísia",
            "country_Name_En": "Tunisia",
            "iso3": "TUN",
            "iso2": "TN",
            "phone_Code": "216"
        },
        {
            "id": 225,
            "country_Name": "Turquia",
            "country_Name_En": "Turkey",
            "iso3": "TUR",
            "iso2": "TR",
            "phone_Code": "90"
        },
        {
            "id": 226,
            "country_Name": "Turcomenistão",
            "country_Name_En": "Turkmenistan",
            "iso3": "TKM",
            "iso2": "TM",
            "phone_Code": "993"
        },
        {
            "id": 227,
            "country_Name": "Ilhas Turcas e Caicos",
            "country_Name_En": "Turks and Caicos Islands",
            "iso3": "TCA",
            "iso2": "TC",
            "phone_Code": "1"
        },
        {
            "id": 228,
            "country_Name": "Tuvalu",
            "country_Name_En": "Tuvalu",
            "iso3": "TUV",
            "iso2": "TV",
            "phone_Code": "688"
        },
        {
            "id": 229,
            "country_Name": "Uganda",
            "country_Name_En": "Uganda",
            "iso3": "UGA",
            "iso2": "UG",
            "phone_Code": "256"
        },
        {
            "id": 230,
            "country_Name": "Ucrânia",
            "country_Name_En": "Ukraine",
            "iso3": "UKR",
            "iso2": "UA",
            "phone_Code": "380"
        },
        {
            "id": 231,
            "country_Name": "Emirados Árabes Unidos",
            "country_Name_En": "United Arab Emirates",
            "iso3": "ARE",
            "iso2": "AE",
            "phone_Code": "971"
        },
        {
            "id": 232,
            "country_Name": "Grã-Bretanha (Reino Unido, UK)",
            "country_Name_En": "United Kingdom",
            "iso3": "GBR",
            "iso2": "GB",
            "phone_Code": "44"
        },
        {
            "id": 233,
            "country_Name": "Estados Unidos",
            "country_Name_En": "United States",
            "iso3": "USA",
            "iso2": "US",
            "phone_Code": "1"
        },
        {
            "id": 234,
            "country_Name": "Ilhas Menores Distantes dos Estados Unidos",
            "country_Name_En": "United States Minor Outlying Islands",
            "iso3": "UMI",
            "iso2": "UM",
            "phone_Code": "1"
        },
        {
            "id": 235,
            "country_Name": "Uruguai",
            "country_Name_En": "Uruguay",
            "iso3": "URY",
            "iso2": "UY",
            "phone_Code": "598"
        },
        {
            "id": 236,
            "country_Name": "Uzbequistão",
            "country_Name_En": "Uzbekistan",
            "iso3": "UZB",
            "iso2": "UZ",
            "phone_Code": "998"
        },
        {
            "id": 237,
            "country_Name": "Vanuatu",
            "country_Name_En": "Vanuatu",
            "iso3": "VUT",
            "iso2": "VU",
            "phone_Code": "678"
        },
        {
            "id": 238,
            "country_Name": "Est. da Cidade do Vaticano",
            "country_Name_En": "Vatican City State (Holy See)",
            "iso3": "VAT",
            "iso2": "VA",
            "phone_Code": "379"
        },
        {
            "id": 239,
            "country_Name": "Venezuela",
            "country_Name_En": "Venezuela",
            "iso3": "VEN",
            "iso2": "VE",
            "phone_Code": "58"
        },
        {
            "id": 240,
            "country_Name": "Vietnã",
            "country_Name_En": "Vietnam",
            "iso3": "VNM",
            "iso2": "VN",
            "phone_Code": "84"
        },
        {
            "id": 241,
            "country_Name": "Ilhas (Britânicas) Virgens",
            "country_Name_En": "Virgin Islands (British)",
            "iso3": "VGB",
            "iso2": "VG",
            "phone_Code": "1"
        },
        {
            "id": 242,
            "country_Name": "Ilhas (E.U.A.) Virgens",
            "country_Name_En": "Virgin Islands (US)",
            "iso3": "VIR",
            "iso2": "VI",
            "phone_Code": "1"
        },
        {
            "id": 243,
            "country_Name": "Ilhas Wallis e Futuna",
            "country_Name_En": "Wallis and Futuna Islands",
            "iso3": "WLF",
            "iso2": "WF",
            "phone_Code": "681"
        },
        {
            "id": 244,
            "country_Name": "Saara Ocidental",
            "country_Name_En": "Western Sahara",
            "iso3": "ESH",
            "iso2": "EH",
            "phone_Code": "212"
        },
        {
            "id": 245,
            "country_Name": "Iêmen",
            "country_Name_En": "Yemen",
            "iso3": "YEM",
            "iso2": "YE",
            "phone_Code": "967"
        },
        {
            "id": 246,
            "country_Name": "Zâmbia",
            "country_Name_En": "Zambia",
            "iso3": "ZMB",
            "iso2": "ZM",
            "phone_Code": "260"
        },
        {
            "id": 247,
            "country_Name": "Zimbábue",
            "country_Name_En": "Zimbabwe",
            "iso3": "ZWE",
            "iso2": "ZW",
            "phone_Code": "263"
        },
        {
            "id": 248,
            "country_Name": "Kosovo",
            "country_Name_En": "Kosovo",
            "iso3": "XKX",
            "iso2": "XK",
            "phone_Code": "383"
        },
        {
            "id": 249,
            "country_Name": "Curaçao",
            "country_Name_En": "Curaçao",
            "iso3": "CUW",
            "iso2": "CW",
            "phone_Code": "599"
        },
        {
            "id": 250,
            "country_Name": "Sint Maarten (parte holandesa",
            "country_Name_En": "Sint Maarten (Dutch part)",
            "iso3": "SXM",
            "iso2": "SX",
            "phone_Code": "1721"
        }
      ],
      DDIList: [],
      ddd: 0,
      selectedPhoneCode: 55,
      isOpen: false,
      processingApi: false,
    };
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
    mask,
  },
  computed: {
    labelStyle() {
      return {
        color: this.template.style.surveyBtnColor,
      };
    },
    selectStyle() {
      return {
        borderTop: "none",
        borderBottom: "none",
        borderRight: "none",
        borderLeft: `2px solid ${this.template.style.surveyTextColor}`,
        color: this.template.style.surveyTextColor,
        fontSize: "1.2rem",
        width: "95px !important",
        height: "46px",
        marginRight: "1px",
        outline: "none",
      };
    },
    inputStyle() {
      return this.template.style.surveyBgColor
        ? {
            backgroundColor: this.template.style.surveyBgColor,
            color: this.template.style.surveyTextColor,
          }
        : {
            color: this.template.style.surveyTextColor,
          };
    },
    getPlaceHolder() {
      return this.placeHolder || this.$t("type_answer_here");
    },
    template() {
      return this.$store.state.template;
    },
  },
  watch: {
    qtAnwser() {
      this.allKeys();
    },
  },
  async mounted() {
    try {
      const selectedCountry = this.CountryList.find(country => country.iso3 === this.template.survey.iso3);
      this.selectedPhoneCode = selectedCountry ? selectedCountry.phone_Code : 55;
      this.DDIList = this.CountryList;
    } catch (error) {
      console.log("Erro ao carregar países:", error.message);
    }

    let answerValue = this.$store.getters.answerValue(this.questionId);

    const areaCodeMatch = answerValue.match(/^\+(\d{1,3})\s+(\d{1,18})?\s*/);

    if (areaCodeMatch) {
        this.selectedPhoneCode = areaCodeMatch[1];
        this.qtAnwser = areaCodeMatch[2];
    } else {
      this.qtAnwser = answerValue;
      this.selectedPhoneCode = '';
      console.log("Código de área ou país não encontrado");
    }

    this.focusInput();
  },
  updated() {
    this.focusInput();
  },
  props: {
    questionText: String,
    questionId: Number,
    placeHolder: String,
    mandatoryQuestion: Boolean,
  },
  methods: {
    focusInput() {
      this.$refs.fc.$el.focus();
    },
    handleSelectChange() {
      let myAnswer = []
      this.selectedPhoneCode ? myAnswer.push('+' + this.selectedPhoneCode + ' ') : null
      this.qtAnwser ? myAnswer.push(this.qtAnwser) : null
      let Anwser = '+' + this.selectedPhoneCode + ' ' + this.qtAnwser.replaceAll("(", "").replaceAll(")","").replaceAll("-","");
      this.$emit("AnswerChanged", myAnswer, this.questionId);
    },
    handleInputChange() {
        let myAnswer = []
        this.selectedPhoneCode ? myAnswer.push('+' + this.selectedPhoneCode + ' ') : null
        this.qtAnwser ? myAnswer.push(this.qtAnwser) : null
        let Anwser = '+' + this.selectedPhoneCode + ' ' + this.qtAnwser.replaceAll("(", "").replaceAll(")","").replaceAll("-","");
        this.$emit("AnswerChanged", myAnswer, this.questionId);
    },
    // async GetCountries() {
    //   const url = "https://security.fanbase.com.br/api/country";
    //   try {
    //     const response = await axios.get(url);
    //     if (response.data.header.codigo === 1) {
    //       return response;
    //     } else {
    //       throw new Error(response.data.header.msg);
    //     }
    //   } catch (error) {
    //     throw new Error("Confirme sua conexão. " + error.message);
    //   }
    // },
    validTelephone(telephone) {
      if (!telephone.length && !this.mandatoryQuestion) return true;
        if (telephone.length >= 5) {
          return !telephone.endsWith(".");
      }
      return false;
    },
    allKeys() {
      let myAnswer = []
      this.selectedPhoneCode ? myAnswer.push('+' + this.selectedPhoneCode + ' ') : null
      this.qtAnwser ? myAnswer.push(this.qtAnwser) : null
      let Anwser = '+' + this.selectedPhoneCode + ' ' + this.qtAnwser.replaceAll("(", "").replaceAll(")","").replaceAll("-","");  
      this.$emit("AnswerChanged", myAnswer, this.questionId);
    },
    enterKey() {
      if (this.validTelephone(this.qtAnwser)) {
        this.processingApi = true;
        let myAnswer = []
        this.selectedPhoneCode ? myAnswer.push('+' + this.selectedPhoneCode + ' ') : null
        this.qtAnwser ? myAnswer.push(this.qtAnwser) : null
        let Anwser = '+' + this.selectedPhoneCode + ' ' + this.qtAnwser.replaceAll("(", "").replaceAll(")","").replaceAll("-","");   
        this.$emit("QuestionAnwered", myAnswer, this.questionId).finally(() => {
          this.processingApi = false;
        });
      } else {
        this.$emit("ErrorOccured", "Telefone inválido.", this.questionId);
      }
    },
    chooseOption(text) {
      if (this.validTelephone(this.qtAnwser)) {
        this.enterKey();
      } else {
        this.qtAnwser += text;
        this.showOptions = false;
        let Anwser = '+' + this.selectedPhoneCode + ' ' + this.qtAnwser.replaceAll("(", "").replaceAll(")","").replaceAll("-","");   
        this.$emit("AnswerChanged", Anwser, this.questionId);
      }
    },
  },
};
</script>

<style scoped>
.title-bold {
  font-family: 'OxaniumBold';
}
#ddd::-webkit-outer-spin-button,
#ddd::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#ddd {
  -moz-appearance: textfield;
}

#telephone::-webkit-outer-spin-button,
#telephone::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#telephone {
  -moz-appearance: textfield;
}
</style>
